export const BREAK_SM = 752
export const BREAK_MD = 972
export const BREAK_LG = 1172
